import { CompanySettings } from "modules/companyAdmin";

const CompanyAdminSettingsPage = () => <CompanySettings />;

export default CompanyAdminSettingsPage;
